<template>
  <base-entities-list
    tag="page"
    :cardComponent="entityComponent"
    :innerTableHeaders="innerHeaders"
    :isHideSites="true"
  ></base-entities-list>
</template>

<script>
import BaseEntitiesList from '../BaseEntitiesList';
import SitePageCard from './SitePageCard';

export default {
  components: {
    BaseEntitiesList
  },

  created() {
    // Загружаем все данные по связанным сущностям
    this.$store.dispatch('sites/loadEntitiesList', {tag: 'specialist'});
    this.$store.dispatch('sites/loadEntitiesList', {tag: 'testimonial'});
    this.$store.dispatch('sites/loadEntitiesList', {tag: 'solution'});
    this.$store.dispatch('sites/loadEntitiesList', {tag: 'portfolio'});
    this.$store.dispatch('sites/loadEntitiesList', {tag: 'question'});
    this.$store.dispatch('estimates/loadList');
  },

  data() {
    return {
      entityComponent: SitePageCard,
      innerHeaders: [
        {
          text: 'Наименование услуги',
          value: 'name'
        },
        {
          text: 'Тэг родителя',
          value: 'parentTag'
        }
      ],
    }
  }
}
</script>